/**
 * @file API service — a2Service.
 * A2 Service
 * All API calls related to A2 stage
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";
import { FormDataResponse } from "../interfaces/formInterfaces";

/**
 * Get form data for A2 stage
 */
export const getA2FormData = async (
  stageCode: string
): Promise<{
  success: boolean;
  data: FormDataResponse | null;
  error?: string;
}> => {
  try {
    const response = await axiosClient.get(API_URLS.FORMS_STAGE(stageCode));
    return {
      success: true,
      data: response.data.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch form data",
      data: null,
    };
  }
};

/**
 * Get submission by ID
 * @param options.params e.g. `{ a2Grouped: true }` for grouped A2 raw material blocks (transport / vehicles / fuels / carbon).
 */
export const getSubmission = async (
  submissionId: string,
  options?: { params?: Record<string, string | number | boolean> }
): Promise<{
  success: boolean;
  data: any | null;
  error?: string;
}> => {
  try {
    const response = await axiosClient.get(API_URLS.SUBMISSIONS.BY_ID(submissionId), {
      params: options?.params,
    });
    return {
      success: true,
      data: response.data.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch submission",
      data: null,
    };
  }
};

/**
 * Save A2 stage data
 */
export const saveA2Details = async (
  submissionId: string,
  payload: any
): Promise<{
  success: boolean;
  message?: string;
  error?: string;
}> => {
  try {
    const response = await axiosClient.put(
      API_URLS.SUBMISSIONS.A2(submissionId),
      payload
    );
    return {
      success: true,
      message: response.data?.message || "A2 data saved successfully",
    };
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to save A2 data";
    return {
      success: false,
      error: errorMessage,
    };
  }
};

